// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getCountries} from '../../shared/repositories';

export const fetchCountries = () =>
    async dispatch => {

        dispatch({
            type: actions.INCREASE_BUSY_COUNTER
        });

        try {

            const data = await getCountries();

            dispatch({
                data,
                type: actions.UPDATE_STATUS_CHANGE_COUNTRIES_SUCCESS
            });

        } catch (error) {

        } finally {

            dispatch({
                type: actions.DECREASE_BUSY_COUNTER
            });

        }

    };



// WEBPACK FOOTER //
// ./src/product/status-change-request/action-creators/countries.js